import { NgModule } from '@angular/core';

import { SearchPipe } from '@app/pipes/search.pipe';
import { DndDirective } from '@app/directives/dnd.directive';
import { RemovePrefixPipe } from '@app/pipes/removePrefix.pipe';
import { MaterialModule } from '@app/material.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IsAllowedDirective } from '@app/directives/is-allowed.directive';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { EditMarkdownComponent } from '@components/edit-markdown/edit-markdown.component';
import { EditHtml } from '@components/edit-html/edit-html';
import { NoDataFoundDirective } from '@app/directives/no-data-found.directive';
import { EditJsonArray } from '@components/edit-json-array/edit-json-array';
import { PrimengModule } from '@app/primeng.module';
import { ShowDirective } from '@app/directives/show.directive';

@NgModule({
	declarations: [
		SearchPipe,
		RemovePrefixPipe,
		IsAllowedDirective,
		DndDirective,
		ShowDirective,
		EditMarkdownComponent,
		EditHtml,
		EditJsonArray,
		NoDataFoundDirective,
	],
	exports: [
		SearchPipe,
		RemovePrefixPipe,
		IsAllowedDirective,
		DndDirective,
		ShowDirective,
		FormsModule,
		MaterialModule,
		PrimengModule,
		CommonModule,
		RouterModule,
		TranslateModule,
		CKEditorModule,
		EditMarkdownComponent,
		EditHtml,
		EditJsonArray,
		NoDataFoundDirective,
	],
	imports: [FormsModule, MaterialModule, CommonModule, RouterModule, TranslateModule, CKEditorModule],
})
export class SharedModule {}
